import { GameLang } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/lang/GameLang";
import { GameLoaderDialogProperties } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/properties/LoaderDialogProperties";
import { GameLoaderStyle } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/style/GameStyle";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { ButtonProperties } from "@lib/titan2/dist/game/control/properties/ButtonProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { AbstractPreloaderProperties } from "@lib/titan2/dist/game/view/properties/AbstractPreloaderProperties";
import { LoaderFontStyle } from "@lib/titan2/dist/game/view/style/CommonFontStyle";
import { LoaderStyle } from "@lib/titan2/dist/game/view/style/CommonStyle";
import * as PIXI from "pixi.js";
/**
 * LoaderLandscapeProperties.ts
 */
export class LoaderLandscapeProperties extends GameLoaderDialogProperties {
    equals(other) {
        return super.equals(other);
    }
    setDefaultValues() {
        super.setDefaultValues();
        this.backgroundProperties.id = GameLoaderStyle.BACKGROUND;
        this.versionFieldProperties.position = new PIXI.Point(1834, 924);
        this.versionFieldProperties.size = new PIXI.Point(200, 100);
        this.copyrightProperties.position = new PIXI.Point(990, 970);
        this.copyrightProperties.size = new PIXI.Point(1200, 75);
        this.copyrightProperties.fontProperties.setLineHeight(28);
        this.playButtonProperties = new ButtonProperties(LoaderStyle.CONTINUE_BUTTON, LoaderStyle.MODULE);
        this.playButtonProperties.textFieldProperties = new TextFieldProperties(LoaderFontStyle.PLAY_BUTTON, null, GameLang.LOADER_PLAY_BUTTON, ControlConstants.CENTER, ControlConstants.CENTER);
        this.playButtonProperties.textFieldProperties.size = new PIXI.Point(290, 120);
        this.playButtonProperties.textFieldOffset.set(0, -8);
        this.playButtonProperties.movieClipProperties.scale.set(1);
        this.playButtonProperties.position.set(806, 750);
        this.playButtonProperties.textFieldProperties.scale.set(1);
        this.playButtonProperties.scale.set(1);
        this.progressFieldProperties.visible = false;
        this.progressBarBackgroundProperties.scale.set(1, 1);
        this.progressBarForegroundProperties.scale.set(1, 1);
        this.progressBarBackgroundProperties.position.set(773, 810);
        this.progressBarForegroundProperties.position.set(783, 812);
        this.infoFieldFooterProperties.position.set(973, 912);
        this.infoFieldFooterProperties.size.set(1000, 75);
        this.infoFieldFooterProperties.fontProperties.setLineHeight(28);
    }
}
/**
 * PreloaderLandscapeProperties.ts
 */
export class PreloaderLandscapeProperties extends AbstractPreloaderProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.spineProperties.position.set(936, 440);
        this.messageSpinePosition = new PIXI.Point(875, 349);
        this.messageProperties.position = new PIXI.Point(665, 550);
        this.messageProperties.size = new PIXI.Point(940, 220);
        this.messageProperties.multiline = true;
    }
}
